import { first, forEach, upperFirst, times, size, toLower } from "lodash";
import Quill from "quill";
import $ from "jquery";

export const getVariablesToInsertByEntityType = entityType => {
  switch (toLower(entityType)) {
    case "offer":
      return OFFER_VARIABLES_TO_INSERT;
    case "reference":
      return REFERENCE_VARIABLES_TO_INSERT;
    default:
      return [];
  }
};

export const BASIC_VARIABLES_TO_INSERT = [
  "my_full_name",
  "my_first_name",
  "my_last_name",
  "organisation_level_one",
  "organisation_level_two",
  "organisation_level_three",
  "organisation_level_four",
  "role_name",
  "role_location",
  "role_contract_type",
  "role_grade",
  "role_working_hours",
  "role_function",
  "candidate_full_name",
  "candidate_last_name",
  "candidate_first_name",
  "apply_link"
];

export const OFFER_VARIABLES_TO_INSERT = [
  "offer_salary",
  "offer_start_date",
  "candidate_full_name",
  "candidate_last_name",
  "candidate_first_name"
];

export const REFERENCE_VARIABLES_TO_INSERT = [
  "reference_experience_job_title",
  "reference_period_start_date",
  "reference_period_end_date",
  "referee_full_name",
  "referee_first_name",
  "referee_last_name"
];

export const ALL_VARIABLES = [
  ...BASIC_VARIABLES_TO_INSERT,
  ...OFFER_VARIABLES_TO_INSERT,
  ...REFERENCE_VARIABLES_TO_INSERT
];

export const getConvertedEmailBody = value => {
  const convertedHtml = document.createElement("div");
  convertedHtml.insertAdjacentHTML("beforeend", value);
  const insertedVariables = convertedHtml.querySelectorAll(".inserted-value");
  forEach(insertedVariables, item => {
    item.removeAttribute("class");
    const childElement = first(item.querySelectorAll("span"));
    // insterted variable should be wrapped in curly braces to be recognized by the API
    if (childElement) {
      childElement.textContent = `{{${childElement.textContent}}}`;
    }
  });
  return convertedHtml.outerHTML;
};

export const addSpaceAfterInsert = quill => {
  const cursorPosition = quill.getSelection().index;
  quill.insertText(cursorPosition + 1, " ", Quill.sources.USER);
  quill.setSelection(cursorPosition + 2, Quill.sources.USER);
};

export const insertVariable = (val, quill) => {
  const cursorPosition = quill.getSelection().index;
  quill.insertEmbed(cursorPosition, "inserted-value", val, Quill.sources.USER);
  addSpaceAfterInsert(quill);
};

export const adjustVariablesTextContent = () => {
  const items = document.querySelectorAll(
    ".ql-insert-variable .ql-picker-item"
  );
  forEach(items, item => {
    const formattedTextContent = getVariableDisplayName(item);
    item.textContent = formattedTextContent;
  });
};

export const adjustAlreadyInsertedVariables = () => {
  forEach(ALL_VARIABLES, variable => {
    $(`.ql-editor:contains(${variable})`).html(function(_, html) {
      const regex = new RegExp(`{{${variable}}}`, "g");
      return html.replace(
        regex,
        `<span class="inserted-value">${variable}</span>`
      );
    });
  });
};

export const getVariableDisplayName = variable => {
  const words = variable.getAttribute("data-value").split("_");
  times(size(words), async i => (words[i] = upperFirst(words[i])));

  return words.join(" ");
};

export const getRelatedToDescriptionFullDescription = ({
  relatedToDescription,
  relatedToId,
  relatedToType
}) => {
  switch (relatedToType) {
    case "booking":
      return `${relatedToDescription}, R-${relatedToId}`;
    case "offer":
      return `${relatedToDescription}, O-${relatedToId}`;
    case "reference":
      return `${relatedToDescription}, Reference`;
    default:
      return "";
  }
};
